<template>
	<div class="reset-password">
		<NavBar :registerPage="true" />
		<v-main>
			<v-row justify="center">
				<v-col lg="4" md="5" sm="7">
					<v-card class="mx-auto mt-3">
						<v-card-title class="primary--text" v-translate>Email confirmation</v-card-title>
						<v-card-text>
							<v-alert v-model="error" color="red lighten-2" class="text-caption" icon="warning">
								<translate>Error.</translate>
							</v-alert>
							<v-alert v-model="success" color="alert" class="text-caption" type="success">
								<translate>Your email was successfully confirmed.</translate>
							</v-alert>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-main>
		<Footer :absolute="true" />
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Footer from "@/components/authentication/Footer.vue";
import axios from "axios";

export default {
	name: "ConfirmAccount",
	components: {
		NavBar,
		Footer
	},
	data: () => ({
		error: false,
		success: false
	}),
	created() {
		const id = this.$route.query.id;
		const token = this.$route.query.token;
		axios
			.post("/confirm_email/" + id + "/" + token)
			.then(response => {
        console.log(response.data);
				if (response.data.result == "confirmed") {
					this.success = true;
				} else {
					this.error = true;
				}
			})
			.catch(error => {
				console.log(error);
				this.error = true;
			});
	}
};
</script>